import React from "react";
import PageHeading from "../../components/PageHeading";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "react-query";
import productServices from "../../services/products";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";
import ProductPrimaryForm from "../../components/Forms/ProductPrimaryForm";
import * as Yup from "yup";
import { imageFormat, imageSize } from "../../utils/functions";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";

const validationSchema = Yup.object().shape({
    productImage: Yup.mixed()
        .test("image-format", "يرجى تحميل صورة", value => {
            if (value) {
                if (value?.type) {
                    return imageFormat.includes(value.type.split("/")[1]);
                }
                return true;
            } else {
                return false;
            }
        })
        .test("img-size", "حجم الصورة لايجب ان يتجاوز 5mb", value => {
            if (value) {
                if (value?.type) {
                    return imageSize >= value.size;
                }
                return true;
            } else {
                return false;
            }
        }),
    productName: Yup.string()
        .required("هذا الحقل مطلوب")
        .min(3, "must be at least 3 character"),
    category: Yup.string().required("هذا الحقل مطلوب"),
});
const EditProduct = ({ title }) => {
    const navigate = useNavigate();
    const { categories } = useSelector(state => state.config);
    const queryClient = useQueryClient();
    const { id } = useParams();
    const { data, isLoading, error } = useQuery(["getProduct", id], () =>
        productServices.getProduct(id)
    );
    const onSubmit = (values, { setSubmitting }) => {
        const formattedData = {
            category_id: values.category,
            name: values.productName,
            orphan: values.orphan,
            is_available: values.is_available,
            order: values.order !== "" ? values.order : null,
        };
        productServices
            .editProduct(formattedData, id)
            .then(res => {
                if (values.productImage !== data.data.data.img) {
                    const formData = new FormData();
                    formData.append("img", values.productImage);
                    productServices
                        .editProductImage(formData, id)
                        .then(res => {
                            toast.success("تم التعديل بنجاح");
                            queryClient.refetchQueries("getProducts");
                            setTimeout(() => {
                                navigate("/products");
                            }, 1500);
                        })
                        .catch(err => {
                            console.log(err);
                            setSubmitting(false);
                        });
                } else {
                    toast.success("تم التعديل بنجاح");
                    queryClient.refetchQueries("getProducts");
                    setTimeout(() => {
                        navigate("/products");
                    }, 1500);
                }
            })
            .catch(err => {
                if (err?.response?.status === 404) {
                    toast.error("السجل غير موجود");
                } else {
                    toast.error("فشل التعديل");
                }
                setTimeout(() => {
                    setSubmitting(false);
                }, 1500);
            });
    };
    if (error || isNaN(Number(id)) || !id) {
        return <Navigate to="/404" />;
    }
    return (
        <div>
            <PageHeading>{title}</PageHeading>
            <DCard className={isLoading ? "min-h-[400px]" : ""}>
                {isLoading ? (
                    <DSpinner />
                ) : (
                    <ProductPrimaryForm
                        validationSchema={validationSchema}
                        initialValues={{
                            category: data.data.data.category_id,
                            productImage: data.data.data.img,
                            productName: data.data.data.name,
                            orphan: data.data.data.orphan === 1 ? true : false,
                            is_available:
                                data.data.data.is_available === 1
                                    ? true
                                    : false,
                            order: data.data.data.order,
                        }}
                        categoriesOptions={categories.data}
                        onSubmit={onSubmit}
                        btnText={"تعديل المنتج"}
                    />
                )}
            </DCard>
        </div>
    );
};

export default EditProduct;
